<script setup lang="ts">
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import MainViewCard from '@/components/common/MainViewCard.vue';
import RecordsTable from '@/components/records/RecordsTable.vue';
import { Button } from '@/components/ui/button';
import { ColumnVisibilityMenu } from '@/components/ui/data-table';
import { useStatusPage } from './useStatusPage';

/*
 * Table-only, unlike every other records page under Pigs - a status registration has no dedicated
 * chart to draw, so this page holds no bins and renders no chart card, just the table on the shared
 * `RecordsTable`. The column-visibility control rides in `RecordsTable`'s own `#actions` slot, beside
 * its heading, the same way Slaughters' does.
 */
const { columnFilters, columns, columnToggleOptions, facetOptions, isError, isFetching, refetch, refreshAfterFormActivity, setAllColumns, sorting, subtitle, toggleColumn, totals, visibleRows } =
    useStatusPage();
</script>

<template>
    <DashboardContentLayout class="space-y-8" :heading="$t('views.pigs.statusRecords.header.heading')" :has-period-picker="true" :has-pig-type-picker="true">
        <div v-if="isError" class="py-14 text-center px-4 text-gray-500 text-lg space-y-4">
            <div>{{ $t('views.pigs.records.errors.couldNotLoadData') }}</div>
            <Button variant="outline" @click="refetch()">{{ $t('views.pigs.records.errors.retry') }}</Button>
        </div>
        <MainViewCard v-else class="overflow-hidden">
            <RecordsTable
                v-model:sorting="sorting"
                v-model:column-filters="columnFilters"
                :columns="columns"
                :rows="visibleRows"
                :totals="totals"
                :facet-options="facetOptions"
                :loading="isFetching"
                :heading="$t('views.pigs.statusRecords.table.heading')"
                :subtitle="subtitle"
                @form-activity="refreshAfterFormActivity"
            >
                <template #actions>
                    <ColumnVisibilityMenu
                        :options="columnToggleOptions"
                        :label="$t('views.pigs.statusRecords.table.columnsButton')"
                        @toggle="toggleColumn"
                        @select-all="setAllColumns(true)"
                        @deselect-all="setAllColumns(false)"
                    />
                </template>
            </RecordsTable>
        </MainViewCard>
    </DashboardContentLayout>
</template>
